import parseISO from 'date-fns/parseISO'
import { localization } from '@ocean/configs'
import { PermissionUtils } from 'utils'
import { Resource } from 'components/common/BigCalendar/types'
import { BigCalendarUtils } from 'components/common/BigCalendar/utils'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import {
  SimulatorTrainingSessionType,
  SimulatorTrainingScheduleSession,
  SimulatorTrainingMaintenancePeriod,
  SimulatorTrainingScheduleSessionEvent,
} from 'modules/simulatorTrainings/common/types'

const { i18n } = localization

class PlannerUtils {
  I18_PLANNER_PATH = `${namespace}:instructor.instructorLed.schedules.planner`

  getResources(): Resource[] {
    const virtualClassroomDenied = PermissionUtils.virtualClassroomDenied()
    const simulatorTrainingResource = {
      resourceId: `${SimulatorTrainingSessionType.SimulatorEnvironment}`,
      resourceTitle: i18n.t(`${this.I18_PLANNER_PATH}.types.training`),
    }
    const virtualClassroomResource = {
      resourceId: `${SimulatorTrainingSessionType.VirtualClassroom}`,
      resourceTitle: i18n.t(`${this.I18_PLANNER_PATH}.types.virtualClassroom1`),
    }

    if (virtualClassroomDenied) return [simulatorTrainingResource]

    return [simulatorTrainingResource, virtualClassroomResource]
  }

  mapSessionToPlanner(
    sessions: SimulatorTrainingScheduleSession[],
    scheduleId?: Guid
  ): SimulatorTrainingScheduleSessionEvent[] {
    const normalizedSessions = sessions.reduce((result, session) => {
      const {
        sessionName,
        startDate,
        endDate,
        sessionId,
        scheduleId: sessionScheduleId,
        type,
      } = session

      if (new Date(startDate) >= new Date(endDate)) return result

      // During creating schedule has same 'sessionId' and 'scheduleId'
      // From API response sessionId and scheduleId both can have null as value
      const isCreatedSession = !!sessionScheduleId && !!sessionId && sessionScheduleId === sessionId
      // Is schedule belongs to route scheduleId
      const isBelongsSchedule = scheduleId === sessionScheduleId
      const isCurrentBooking = isBelongsSchedule || isCreatedSession

      const plannerSession: SimulatorTrainingScheduleSessionEvent = {
        id: sessionId,
        scheduleId: sessionScheduleId,
        title: sessionName,
        start: parseISO(startDate),
        end: parseISO(endDate),
        // String because validation on falsy into 'react-big-calendar'
        resourceId: `${type}`,
        currentBooking: isCurrentBooking,
      }

      return [...result, plannerSession]
    }, [] as SimulatorTrainingScheduleSessionEvent[])

    return normalizedSessions
  }

  mapMaintenancePeriodsToPlanner(
    maintenancePeriods: SimulatorTrainingMaintenancePeriod[]
  ): SimulatorTrainingScheduleSessionEvent[] {
    return maintenancePeriods.reduce((result, period, index) => {
      const { startDate, endDate } = period

      if (new Date(startDate) >= new Date(endDate)) return result

      const plannerSession: SimulatorTrainingScheduleSessionEvent = {
        id: `maintenance_${index}`,
        title: i18n.t(`${BigCalendarUtils.I18_PATH}.maintenance`),
        start: parseISO(startDate),
        end: parseISO(endDate),
        // String because validation on falsy into 'react-big-calendar'
        resourceId: `${SimulatorTrainingSessionType.SimulatorEnvironment}`,
        inactive: true,
      }

      return [...result, plannerSession]
    }, [] as SimulatorTrainingScheduleSessionEvent[])
  }

  getResourceName(id: string) {
    const resources = this.getResources()
    const resource = resources.find(({ resourceId }) => resourceId === id)
    return resource?.resourceTitle || ''
  }
}

export default new PlannerUtils()
